import FlexBox from '@/atomic-components/FlexBox';
import { LencoImage } from '@/atomic-components/Image';
import { getColor } from '@/utils/theme/colors';
import { getStyle } from '@/utils/theme/fonts';
import { Box, Drawer, Tab, Tabs } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import { Thumbnail } from './modal';
import ImportantTermsIcon from '../../../../assets/pdp/importantTerms.svg';
import ArrowWithCircle from '../../../../assets/pdp/svgwithProps/arrowWithCircle1';
import RightArrowIconWithColor from '../../../../assets/pdp/rightArrowIconWithMintyColor.svg';
import { useState } from 'react';
import SpecificationData from './specificationData';
import StorytellingDataComponent from '../StoryTelling';
import CrossIcon from '../../../../assets/pdp/crossIcon.svg';
import ProductDesignFeatureGalleryComponent from './productDesignGallery';
import ExtraFeaturesDrawerComponent from '../../extraFeaturesDrawer';
import FrequentlyAskedQuestions from '../../frequntlyAskedQues';
import AwardInformationComponent from '../Awards';
import { Inclusion } from '@/services/catalogue/models/pdp';
import DesignFeatureCarousel from '@/atomic-components/carousels/wrappers/design-feature-carousel';
import CareInstructionIcon from '@/assets/pdp/svgwithProps/careInstruction1';
import CancellationAndReturnsIconFile from '@/assets/pdp/svgwithProps/cancellationAndReturns';
import WarrantyIcon from '@/assets/pdp/svgwithProps/warrantyICon1';
import QualityPerformanceIcon from '@/assets/pdp/svgwithProps/qualityIcon1';
import FAQIcon from '@/assets/pdp/svgwithProps/faq';
interface TabPanelProps {
	children?: React.ReactNode;
	index: number;
	value: number;
}

function TabPanel(props: TabPanelProps) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role='tabpanel'
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box sx={{ p: 3 }}>
					<LencoTypography>{children}</LencoTypography>
				</Box>
			)}
		</div>
	);
}

function a11yProps(index: number) {
	return {
		id: `simple-tab-${index}`,
		'aria-controls': `simple-tabpanel-${index}`,
	};
}

interface InclusionProductDataTabComponentProps {
	inclusions: Inclusion[];
	storyTelling?: StorytellingData;
	setOpenDrawerToSeeAllProducts: () => void;
	openDrawerToSeeAllProducts: boolean;
	lineOfProduct: string;
	faq: any;
	awards: string[];
}

export interface StorytellingData {
	label: string;
	subtitle: string;
	images: Thumbnail[];
	desktopImages: Thumbnail[];
}

interface ISpecificationsAndInclusionsIconProps {
	cancellationAndReturns: any;
	careInstructions: any;
	qualityPerformance: any;
	warranty: any;
	faq: any;
	importantTerms: any;
}

const InclusionProductDataTabComponent = (
	props: InclusionProductDataTabComponentProps
) => {
	const { inclusions } = props;
	const [openDrawerToSeeData, setOpenDrawerToSeeData] = useState(false);
	const [value, setValue] = useState(0);
	const [openProductGallery, setOpenProductGallery] = useState(false);
	const [openExtraFeatureDrawer, setOpenExtraFeatureDrawer] = useState(false);
	const [extraFeatureData, setExtraFeatureData] = useState('');
	const [openFAQ, setOpenFAQ] = useState(false);
	const [idx, setIdx] = useState(0);

	const SpecificationsAndInclusionsIconMApper: ISpecificationsAndInclusionsIconProps =
		{
			cancellationAndReturns: {
				icon: (label: string) => {
					if (label === svgColorData)
						return <CancellationAndReturnsIconFile fill='#047992' />;
					else return <CancellationAndReturnsIconFile />;
				},
				arrowIcon: (label: string) => {
					if (label === svgColorData) return <ArrowWithCircle fill='#047992' />;
					else return <ArrowWithCircle />;
				},
				label: 'Cancellation And Returns',
			},
			careInstructions: {
				icon: (label: string) => {
					if (label === svgColorData)
						return <CareInstructionIcon fill='#047992' />;
					else return <CareInstructionIcon />;
				},
				arrowIcon: (label: string) => {
					if (label === svgColorData) return <ArrowWithCircle fill='#047992' />;
					else return <ArrowWithCircle />;
				},
				label: 'Care Instruction',
			},
			qualityPerformance: {
				icon: (label: string) => {
					if (label === svgColorData)
						return <QualityPerformanceIcon fill='#047992' />;
					else return <QualityPerformanceIcon />;
				},
				arrowIcon: (label: string) => {
					if (label === svgColorData) return <ArrowWithCircle fill='#047992' />;
					else return <ArrowWithCircle />;
				},
				label: 'Quality Performance',
			},
			warranty: {
				icon: (label: string) => {
					if (label === svgColorData) return <WarrantyIcon fill='#047992' />;
					else return <WarrantyIcon />;
				},
				arrowIcon: (label: string) => {
					if (label === svgColorData) return <ArrowWithCircle fill='#047992' />;
					else return <ArrowWithCircle />;
				},
				label: 'Warranty',
			},
			faq: {
				icon: (label: string) => {
					if (label === svgColorData) return <FAQIcon fill='#047992' />;
					else return <FAQIcon />;
				},
				arrowIcon: (label: string) => {
					if (label === svgColorData) return <ArrowWithCircle fill='#047992' />;
					else return <ArrowWithCircle />;
				},
				label: 'FAQ',
			},
			importantTerms: {
				icon: (color: string) => <CareInstructionIcon fill={color} />,
				arrowIcon: (label: string) => {
					if (label === svgColorData) return <ArrowWithCircle fill='#047992' />;
					else return <ArrowWithCircle />;
				},
				label: 'Important Terms',
			},
		};

	const QualityAndStuffArray = [
		'cancellationAndReturns',
		'careInstructions',
		'qualityPerformance',
		'warranty',
		'faq',
		'importantTerms',
	];

	const handleChange = (event: React.SyntheticEvent, newValue: number) => {
		setValue(newValue);
	};

	const handleProductGallery = (openGallary: boolean, index: number) => {
		setOpenProductGallery(true);
		setIdx(index);
	};

	const handleOpenExtraProductDrawer = (data: string) => {
		data == 'faq'
			? setOpenFAQ(true)
			: (setOpenExtraFeatureDrawer(true), setExtraFeatureData(data));
	};

	const changeSvgColor = (data: any) => {
		setSvgColorData(`${data}`);
	};

	const InclusionProductLabel = props.inclusions.map((d) => d.label);
	const [svgColorData, setSvgColorData] = useState('');
	return (
		<Drawer
			anchor='right'
			open={props.openDrawerToSeeAllProducts}
			onClose={props.setOpenDrawerToSeeAllProducts}
		>
			<FlexBox direction='column' sx={{ padding: '80px' }}>
				<FlexBox sx={{ justifyContent: 'end', cursor: 'pointer' }}>
					<Box onClick={props.setOpenDrawerToSeeAllProducts}>
						<CrossIcon />
					</Box>
				</FlexBox>
				{props.lineOfProduct != 'ITEM' && (
					<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
						<Tabs
							value={value}
							onChange={handleChange}
							aria-label='basic tabs example'
						>
							{InclusionProductLabel?.map((label, index) => {
								return (
									<Tab
										label={label}
										{...a11yProps(index)}
										key={index}
										style={{ textTransform: 'capitalize' }}
									/>
								);
							})}
						</Tabs>
					</Box>
				)}

				{props?.inclusions?.map((inclusionData, index) => {
					const inclusion = inclusionData;

					return (
						<TabPanel value={value} index={index} key={index}>
							<FlexBox
								direction='column'
								sx={{ padding: '20px', width: '55vw' }}
							>
								<FlexBox>
									<FlexBox
										direction='column'
										sx={{
											width: '480px',
											backgroundColor: 'white',
											paddingRight: '40px',
										}}
									>
										<FlexBox>
											<Box
												sx={{
													width: '480px',
													height: '480px',
													background:
														'linear-gradient(180deg, #FFFFFF 0.09%, #F3F3F3 100%)',
												}}
											>
												<LencoImage
													url={inclusion?.thumbnail?.url}
													aspectRatio={inclusion?.thumbnail?.aspectRatio}
												/>
											</Box>
										</FlexBox>
										<FlexBox
											direction='column'
											sx={{ paddingTop: '46px', paddingBottom: '40px' }}
										>
											{inclusion?.description && (
												<LencoTypography
													sx={{
														...getStyle('P_Regular'),
														color: getColor('Gray -1'),
														paddingBottom: '40px',
													}}
												>
													{inclusion.description}
												</LencoTypography>
											)}
											{QualityAndStuffArray?.filter((d) => {
												if (d != 'faq') {
													if (inclusion.hasOwnProperty(d)) {
														return inclusion[d as keyof Inclusion];
													}
												} else {
													return 'faq';
												}
											}).map((data, index) => {
												return (
													<FlexBox
														direction='column'
														sx={{
															width: '95%',
															'&:hover': {
																background: '#FFFFFF',
																boxShadow: '0px 8px 8px rgba(34, 34, 34, 0.1)',
																color: getColor('Minty +1'),
															},
														}}
														onMouseEnter={() => {
															changeSvgColor(data);
														}}
														onMouseLeave={() => {
															changeSvgColor('');
														}}
														key={index}
													>
														<Box
															sx={{
																width: '100%',
																borderTop: `1px solid ${getColor('Gray -4')}`,
															}}
														></Box>
														<FlexBox
															onClick={() => {
																handleOpenExtraProductDrawer(data);
															}}
															sx={{
																justifyContent: 'space-between',
																width: '100%',
																padding: '20px',
																alignItems: 'center',
																cursor: 'pointer',
															}}
														>
															<FlexBox>
																{SpecificationsAndInclusionsIconMApper[
																	data as keyof ISpecificationsAndInclusionsIconProps
																]?.icon(data)}

																<LencoTypography
																	sx={{
																		...getStyle('P_Medium'),
																		paddingLeft: '16px',
																	}}
																>
																	{
																		SpecificationsAndInclusionsIconMApper[
																			data as keyof ISpecificationsAndInclusionsIconProps
																		]?.label
																	}
																</LencoTypography>
															</FlexBox>
															<Box>
																{SpecificationsAndInclusionsIconMApper[
																	data as keyof ISpecificationsAndInclusionsIconProps
																]?.arrowIcon(data)}
															</Box>
														</FlexBox>
													</FlexBox>
												);
											})}
										</FlexBox>
									</FlexBox>
									<SpecificationData
										specifications={inclusion?.specifications}
									/>
								</FlexBox>
								<FlexBox direction='column' sx={{ width: '100%' }}>
									{inclusion?.designFeatures?.length > 0 && (
										<Box sx={{ paddingBottom: '40px' }}>
											<LencoTypography
												sx={{
													...getStyle('H6_Medium'),
													color: getColor('Gray 0'),
													paddingBottom: '48px',
												}}
											>
												Design features
											</LencoTypography>
											<DesignFeatureCarousel
												spaceBetween={20}
												slidesPerView={1.75}
												dots={true}
												isLeftAligned={true}
											>
												{inclusion?.designFeatures?.map(
													(designFeature, index) => {
														return (
															<FlexBox
																key={index}
																sx={{
																	width: 'auto',
																	height: '260px',
																	background: '#FFFFFF',
																	boxShadow:
																		'0px 0px 24px rgba(34, 34, 34, 0.1)',
																	borderRadius: '16px',
																	// border: '1px solid #FFFFFF',
																	padding: '20px',
																	alignItems: 'center',
																}}
															>
																<FlexBox>
																	<Box
																		key={designFeature?.label}
																		sx={{
																			minWidth: '100px',
																			height: '100px',
																			margin: '12px',
																			borderRadius: '50%',
																			overflow: 'hidden',
																		}}
																	>
																		<LencoImage
																			url={designFeature?.thumbnail?.url}
																			aspectRatio={
																				designFeature?.thumbnail?.aspectRatio
																			}
																		/>
																	</Box>
																</FlexBox>

																<FlexBox
																	direction='column'
																	sx={{ alignContent: 'center' }}
																>
																	<LencoTypography
																		sx={{
																			...getStyle('H10_Medium'),
																			color: getColor('Gray 0'),
																		}}
																	>
																		{designFeature?.label}
																	</LencoTypography>
																	<LencoTypography
																		sx={{
																			...getStyle('P_Regular'),
																			color: getColor('Gray -2'),
																		}}
																	>
																		{designFeature?.description}
																	</LencoTypography>

																	<FlexBox
																		sx={{
																			alignItems: 'center',
																			cursor: 'pointer',
																			// paddingBottom: '40px',
																			'&:hover': {
																				'#typo': {
																					...getStyle('P_SemiBold'),
																				},
																			},
																		}}
																		onClick={() => {
																			handleProductGallery(true, index);
																		}}
																	>
																		<LencoTypography
																			id='typo'
																			sx={{
																				...getStyle('P_Medium'),
																				color: getColor('Minty +1'),
																				paddingRight: '4px',
																			}}
																		>
																			Read more{' '}
																		</LencoTypography>
																		<Box sx={{ paddingTop: '2px' }}>
																			<RightArrowIconWithColor />
																		</Box>
																	</FlexBox>
																</FlexBox>
															</FlexBox>
														);
													}
												)}
											</DesignFeatureCarousel>
										</Box>
									)}
									<StorytellingDataComponent
										storytelling={props?.storyTelling as StorytellingData}
									/>
									<Box sx={{ width: '100%' }}>
										<AwardInformationComponent awards={props?.awards} />
									</Box>
								</FlexBox>
							</FlexBox>

							<ProductDesignFeatureGalleryComponent
								designFeatures={inclusion.designFeatures[idx]}
								setOpenProductGallery={() => setOpenProductGallery(false)}
								openProductGallery={openProductGallery}
							/>

							<ExtraFeaturesDrawerComponent
								openDrawerToSeeDescription={openExtraFeatureDrawer}
								setOpenExtraFeatureDrawer={() =>
									setOpenExtraFeatureDrawer(false)
								}
								icon={SpecificationsAndInclusionsIconMApper[
									extraFeatureData as keyof ISpecificationsAndInclusionsIconProps
								]?.icon(extraFeatureData)}
								data={
									inclusion[extraFeatureData as keyof Inclusion]
										? inclusion[extraFeatureData as keyof Inclusion]
										: ''
								}
							/>

							<FrequentlyAskedQuestions
								details={props?.faq}
								isOpen={openFAQ}
								onClose={() => setOpenFAQ(false)}
							/>
						</TabPanel>
					);
				})}
			</FlexBox>
		</Drawer>
	);
};

export default InclusionProductDataTabComponent;
